import { Instagram, ArrowRight } from "lucide-react";

const INSTAGRAM_URL = "https://instagram.com/creatori.fi";

const COPY = {
  creator: {
    heading: "Älä missaa uusia kampanjoita",
    sub: "Seuraa meitä Instagramissa ja saat tiedon aina uusista kampanjoista.",
  },
  business: {
    heading: "Pysy mukana Creatorin matkassa",
    sub: "Seuraa meitä Instagramissa ja näet uusimmat uutiset, vinkit ja Creatorin kuulumiset.",
  },
};

export function InstagramPromo({ role = "creator" }) {
  const c = COPY[role] || COPY.creator;
  return (
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="instagram-promo"
      className="group block overflow-hidden rounded-3xl border border-[#E6E1D9] bg-white soft-shadow transition-[transform,box-shadow] duration-300 ease-out hover:soft-shadow-hover hover:-translate-y-0.5"
    >
      <div className="flex flex-col sm:flex-row">
        <div className="h-44 sm:h-56 sm:w-2/5 lg:w-1/3 shrink-0 overflow-hidden bg-[#EAF1FB]">
          <img
            src="/instagram-promo.png"
            alt="Creatori Instagramissa"
            loading="lazy"
            className="h-full w-full object-contain transition-transform duration-500 ease-out group-hover:scale-[1.03]"
          />
        </div>
        <div className="flex-1 p-6 sm:p-8 flex flex-col justify-center">
          <span className="inline-flex items-center gap-1.5 text-[12px] font-medium uppercase tracking-wide text-[#968F85]">
            <Instagram size={14} strokeWidth={2} /> Instagram
          </span>
          <h3 className="mt-2 text-xl sm:text-2xl font-semibold tracking-display text-[#292827] leading-snug">{c.heading}</h3>
          <p className="mt-2 max-w-md text-[15px] text-[#6E675C] leading-relaxed">{c.sub}</p>
          <span
            data-testid="instagram-promo-cta"
            className="mt-5 inline-flex items-center gap-1.5 self-start rounded-full bg-[#292827] px-5 py-2.5 text-[14px] font-medium text-white transition-colors group-hover:bg-[#1c1b1a]"
          >
            Seuraa Instagramissa <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5" />
          </span>
        </div>
      </div>
    </a>
  );
}
